import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import TruckerDetails from './TruckerDetails'; 
import { Tab, Tabs, Row, Col } from 'react-bootstrap';
import Trash from "../../../assets/images/delete.svg";
import Arcv from "../../../assets/images/archive.svg";   
import Active from "../../../assets/images/active.svg";  
import Select from 'react-select'
import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faBoxArchive } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ADDTRUCKER, TRUCKERGRID, TRUCKERACTIVE, TRUCKERARCHIVE, TRUCKERTRASH, GETOWNERCODE, STATIONGRID } from '../../../Utils/conts.js';

const TruckerSetting = () => {


    const isMounted = useRef(false);
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
        Trash: useRef(null),
    };
    const [truckerData, setTruckerData] = useState({
        Active: [],
        Archived: [],
        Trash: []
    });

    // const [gridData, setTruckerData] = useState([{
    //     name: "aaaaaaaa",
    //     email: "444",
    //     number: "sdasadsad"
    // }]);
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(TRUCKERGRID, { status: activeTab })
                .then(function (res) {
                    const innerData = res.data.response_data;

                    setTruckerData({ innerData });
                });


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (isMounted.current) return;
        fetchDataGrid();
        isMounted.current = true;
    }, []);

    const [modalShow, setModalShow] = useState(false);
    const [modalPos, setModalPos] = useState('');
    const [reload, setReload] = useState(false);
    const [formData, setFormData] = useState({
        truckerName: '',
        truckerEmail: '',
        TruckerPhone: ''
    });

    const [activeTab, setActiveTab] = useState('Active');
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);

    const handleDetailsBackClick = (rowData) => {
        setShowDetails(false);
    };

    const handleModalClose = () => {
        setModalShow(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const validateEmail = (email) => emailRegex.test(email);
        if (!formData.truckerName?.trim()) {
            toast.error('Trucker Name must not be blank');
            isValid = false;
        }
        else if (formData.TruckerPhone && !/^\d{10}$/.test(formData.TruckerPhone)) {
            toast.error('Phone Number must be 10 Digits');
            isValid = false;
        }
        else if (formData.truckerEmail && !validateEmail(formData.truckerEmail)) {
            toast.error('Invalid email address');
            isValid = false;
        }
        return isValid;
    };
    const handleAddCarrier = async () => {
        if (validateFormData()) {
            const newData = {
                TruckerName: formData.truckerName,
                TruckerEmail: formData.truckerEmail,
                TruckerPhone: formData.TruckerPhone
            };

            try {
                const res = await withRFSToken.post(ADDTRUCKER, formData)
                    .then(function (res) {
                        if (res.data.response_code == 200) {
                            setTruckerData(res.data.response_data)
                            toast.success('Trucker Added Successfully')
                            reloadGrid(activeTab);
                            setReload(prev => !prev);
                        }
                    });

            } catch (error) {
                console.error('Error sending request:', error);
            }
            setFormData({
                truckerName: '',
                truckerEmail: '',
                TruckerPhone: ''
            });
            setModalShow(false);
        }
    };

    let checkUlds = [];
    let filterForCheck = [];
    useEffect(() => {
        if (gridRefs[activeTab] && !showDetails) {
            const localData = truckerData;
            var token = "Bearer " + localStorage.SPL;
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'airline_code', type: 'string' },
                    { name: 'airline_master', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'email_notification_status', type: 'string' },
                    { name: 'id', type: 'string' },
                    { name: 'org_name', type: 'string' },
                    { name: 'phone', type: 'string' },
                    { name: 'pickup_emails', type: 'string' },

                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}rfs-setting/org-list?org_type=T`,
                beforeSend: function (jqXHR) {
                    jqXHR.setRequestHeader('Authorization', token);
                },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Truckersss Name', filtertype: 'textbox', datafield: 'org_name', width: '15%' },
                { text: 'Email', filtertype: 'textbox', datafield: 'email', width: '20%' },
                { text: 'Phone Number', filtertype: 'textbox', datafield: 'phone', width: '10%' },
                {
                    text: 'Pickup Emails', filtertype: 'textbox', datafield: 'pickup_emails', width: '55%', cellclassname: '',                    
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            defaultHtml = "<div class='jqx-grid-cell-left-align' style='margin-top: 13px;'>"+JSON.parse(cellValue)+"</div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: 'checkbox',
                pageable: false,
                pageSize: 10,
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 40,
                showfilterrow: true,
                rowsheight: 42,
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('rowclick', (event) => {

                const args = event.args.row.bounddata;

                setSelectedRowData(event);
                setShowDetails(true);
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.trucker_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.trucker_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.trucker_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.trucker_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.trucker_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
        }
    }, [showDetails]);

    const reloadGrid = async (tab) => {
        try {
            const res = await withRFSToken.post(TRUCKERGRID, { status: tab })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setTruckerData(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleEditClick = (data) => {

        setModalPos(data.position)
        const { position, ...rest } = data;
        setModalShow(true);
        setFormData(rest);
    };

    const SBack = localStorage.getItem('SettingsBack');

    return (
        // <div className="">
        //     <Header logo_url={SBack ? SBack : '/PlanningDashboard'} sBackUrl={SBack ? SBack : '/PlanningDashboard'} />
        //     <div className="main-panel">
        //         <div className="row">
        //             <LeftSettings />
                    <div className='col-9 col-xxl-9 stting_right'>
                        <div className='settingbg_right'>
                            {!showDetails &&
                                <>
                                    <h4>Trucker Settings</h4>
                                    <p>Manage trucker contact information</p>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div ref={gridRefs.Active} className='staion_grid' ></div>
                                        </div>
                                    </div>
                                </>
                            }
                            {showDetails && (
                                <>
                                    <button className='backbtn' onClick={handleDetailsBackClick}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
                                    <TruckerDetails rowData={selectedRowData} reload={fetchDataGrid} dload={reload} onEdit={handleEditClick} />
                                </>
                            )}

                        </div>
                    </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default TruckerSetting